<template>
  <a-spin :spinning="spinning" tip="数据加载中...">
    <div class="check-container">
      <a-layout>
        <a-page-header
          class="check-group-name"
          sub-title=""
          @back="() => $router.go(-1)"
        >
          <template slot="title">
            <div class="title-left">
              <span class="title-h1">{{ studentName }}</span>
              <span>第{{ lessonNum }}讲&nbsp;&nbsp;{{ lessonName }}</span>
              <i class="link-type">{{ linkTypeName }}</i>
            </div>
            <div class="title-right">
              <span class="title-h2">{{ groupName }}</span>
              <span v-if="userId">学生ID: {{ userId }}</span>
              <span v-if="optTime">{{ optTime | formatDate }}</span>
            </div>
          </template>
        </a-page-header>
        <a-layout>
          <a-layout-content>
            <CorrectStage
              v-if="showCorrect"
              ref="correctStage"
              :query="query"
              :user-id="userId"
              :link-type-name="linkTypeName"
              :link-type="linkType"
              @afterData="afterCorrentData"
              @isLastChange="isLastImgChange"
              @changeTool="changeTool"
              @showAnswer="showAnswer"
              @noCorrect="noCorrect"
              @objectDelete="objectDelete"
              @scoreIndexChange="val => scoreIndex = val"
              @initSuc="initSuc"
              @imgPageChange="imgPageChange"
            />
          </a-layout-content>
          <a-layout-sider
            width="340"
            class="info"
          >
            <CorrectOperate
              v-if="showCorrect"
              ref="correctOperate"
              class="operate-right-top"
              @resultChange="resultChange"
              @markScore="markScore"
              :is-last-img="isLastImg"
              :score-index="scoreIndex"
              :is-show-score="isShowScore"
              :link-type-name="linkTypeName"
              @isResultChange="isResultChange"
              @firstScoreClick="firstScoreClick"
            />
            <div class="send-stu-btn">
              <!-- TODO disabled -->
              <a-button
                type="danger"
                @click="submitConfirm"
                :loading="confirmLoading"
                :disabled="confirmDisabled || isSubmitDisabled"
              >
                {{ submitTxt }}
              </a-button>
            </div>
          </a-layout-sider>
        </a-layout>
      </a-layout>
      <!-- 日积月累查看答案 -->
      <TopicDrawer
        v-if="isWorkword"
        :class-type-id="query.classTypeId"
        :lesson-id="query.lessonId"
        :ai-lesson-id="query.aiLessonId"
        ref="answerModal"
      />
      <!-- 融汇贯通答案 -->
      <PicDrawer
        v-if="isFirstExamWord"
        :class-type-id="query.classTypeId"
        :lesson-id="query.lessonId"
        :ai-lesson-id="query.aiLessonId"
        :is-img="true"
        ref="answerModal"
      />
    </div>
  </a-spin>
</template>
<script>
import TopicDrawer from '@/components/Answer/TopicDrawer.vue'
import PicDrawer from '@/components/Answer/PicDrawer.vue'

import { message } from 'ant-design-vue'
import correctLogger from '@/utils/logger/correct.js'
import CorrectStage from '@/components/Correct/CorrectStage.vue'
import CorrectOperate from '@/components/Correct/CorrectOperate.vue'
import { kibanaErrorLog, kibanaInfoLog } from '@/utils/kibana/kibanaLog.js'
import { mapGetters } from 'vuex'
import { isNumeric } from '@/utils/index.js'
import CacheFunction from '@/utils/CacheFunction.js'
import { getUploadSign } from '@/utils/upload.js'

const SUBMIT_TXT = '提交批改'
export default {
  name: 'Checktool',
  components: {
    TopicDrawer,
    PicDrawer,
    CorrectStage,
    CorrectOperate
  },
  data() {
    return {
      userId: null,
      // 学生姓名
      studentName: '',
      // 小关名称
      linkTypeName: '',
      linkId: null,
      // 学生操作时间
      optTime: null,
      submitTxt: SUBMIT_TXT,
      // 剩余批改的份数
      residueCount: 0,
      showCorrect: true,
      // 环节类型  拍课本、日积月累、融会贯通。。。
      linkType: null,
      // 提交批改置灰，只有选择批改结果才可以
      confirmDisabled: true,
      // 是否为最后一张图片
      isLastImg: false,
      // 当前打分的图片索引
      scoreIndex: null,
      // 请求接口数据
      spinning: true,
      // 提交批改是否置灰
      isSubmitDisabled: true
    }
  },
  computed: {
    query () {
      return this.$route.query
    },
    // 讲次数
    lessonNum() {
      return this.query.lessonNum
    },
    // 讲次名称
    lessonName() {
      return this.query.lessonName
    },
    // 小组名称
    groupName() {
      return this.query.groupName
    },
    // 是否为课本例练
    isCourseExerc() {
      return this.linkType === 2
    },
    // 是否为双色笔记
    isDoubleColor() {
      return this.linkType === 3
    },
    // 是否为日积月累
    isWorkword() {
      return this.linkType === 4
    },
    // 是否为融汇贯通
    isFirstExamWord() {
      return this.linkType === 5
    },
    /**
     * 是否显示印章
     * 只有课本例练，双色笔记显示印章
     */
    isShowSeal() {
      const { isCourseExerc, isDoubleColor } = this
      return isCourseExerc || isDoubleColor
    },
    /**
     * 是否显示打分
     * 只有日积月累和融会贯通显示打分
     */
    isShowScore() {
      const { isWorkword, isFirstExamWord } = this
      return isWorkword || isFirstExamWord
    },
    // 是否显示查看答案
    isShowAnswer() {
      const { isWorkword, isFirstExamWord } = this
      return isWorkword || isFirstExamWord
    },
    // 1:确定下一份（有下一份）  2：确认（没有下一份）
    buttonType() {
      const { residueCount } = this
      return residueCount > 0 ? 1 : 2
    },
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    })
  },
  watch: {
    confirmLoading(val) {
      if (!val) {
        this.submitTxt = SUBMIT_TXT
      }
    }
  },
  created() {
    // 从链接里带过来的 userId
    this.userId = Number(this.query.userId)
    this.linkType = Number(this.query.linkType)
    this.warnSpeed = 3000 // 异常提示延迟处理
  },
  mounted() {
    // 计时，用于算埋点的批改时间
    this.correctTime = this.getCurTime()
  },
  methods: {
    getCurTime() {
      return new Date().getTime()
    },
    // 初始化完成
    initSuc(imgData) {
      this.spinning = false
      // 预获取上传的 key，有效期4个小时
      this.uploadKeys = new CacheFunction(async () => {
        // 图片上传的 key
        const imgFileNames = Array.from(imgData.keys()).map(index => ({
          name: imgData.get(index).name
        }))
        // 音频的名称
        const audioName = `correct-audio-${new Date().getTime()}.mp3`
        this.audioName = audioName
        const signArr = [
          ...imgFileNames,
          {
            name: audioName
          }
        ]
        const { signature, storageTime } = await getUploadSign(signArr)
        // 通过文件名称可以获取对应的 签名
        const signMap = new Map()
        signArr.forEach(({ name }, index) => signMap.set(name, signature[index]))
        return {
          signMap,
          storageTime
        }
      })
      // 预获取一次
      this.uploadKeys.getResult()
    },
    /**
    * 给学生信息赋值
    */
    afterCorrentData({ userId, userName, linkType, linkTypeName, linkId, optTime, residueCount, linkDetailList }) {
      this.userId = userId
      this.studentName = userName
      this.linkType = linkType
      this.linkTypeName = linkTypeName
      this.linkId = linkId
      this.optTime = optTime
      this.residueCount = residueCount
      if (!linkDetailList || !linkDetailList.length) {
        // 已经批改过了，老版本没有，加上
        message.error('暂无要批改的内容')
        this.clearWarnTimer()
        this.warnTimeOutTimer = setTimeout(() => {
          this.goRouter('checkDetailsPage', this.query)
        }, this.warnSpeed)
      }
    },
    /**
     * 是否为最后一张图片
     */
    isLastImgChange(val) {
      this.isLastImg = val
    },
    /**
     * 批改结果改变
     */
    isResultChange(val) {
      this.isSubmitDisabled = val === 0
    },
    /**
     * 提交批改
     */
    submitConfirm() {
      if (this.confirmLoading) {
        return
      }
      this.confirmLoading = true
      this.submitTxt = '提交批改中'
      this.postCorrectionData().finally(() => {
        this.submitTxt = SUBMIT_TXT
        this.confirmLoading = false
      }).catch(e => {
        this.correctErrorLog({
          eventName: '提交批改出错',
          errorMessage: e.message
        })
      })
    },
    /**
     * 提交批改的处理
     */
    async postCorrectionData() {
      let audioUrl
      let audioDuration
      let detailList
      let imgUploadTime
      let imgUploadNum
      let imgUploadFiles
      let imgStorageTime
      let imgCreateTime
      const allTime = this.getCurTime()
      let audioUploadTime = 0
      try {
        audioUploadTime = this.getCurTime()
        this.submitTxt = '录音上传中'
        const recordRes = await this.$refs.correctOperate.getRecord(this.uploadKeys, this.audioName)
        // 录音了
        if (recordRes) {
          const { errorMsg } = recordRes
          if (errorMsg) {
            message.error(errorMsg)
            return
          }
          audioUrl = recordRes.audioUrl
          audioDuration = recordRes.audioDuration
          audioUploadTime = this.getCurTime() - audioUploadTime
        } else {
          audioUploadTime = 0
        }
      } catch (e) {
        message.error(`上传录音出错：${e.message}`)
        this.correctErrorLog({
          eventName: '上传录音出错',
          errorMessage: e.message
        })
        return
      }

      try {
        this.submitTxt = '图片上传中'
        const { imgs, uploadNum, uploadImgUrls, uploadAllTime, storageTime, canvasTime } = await this.$refs.correctStage.save(this.uploadKeys)
        detailList = imgs
        imgUploadTime = uploadAllTime
        imgUploadNum = uploadNum
        imgUploadFiles = uploadImgUrls
        imgStorageTime = storageTime
        imgCreateTime = canvasTime
      } catch (e) {
        let errMsg = '上传图片出错'
        if (e) {
          const { errorMessage, message } = e
          if (errorMessage) {
            errMsg += ` ${errorMessage}`
          }
          if (message) {
            errMsg += ` ${message}`
          }
        }
        message.error(errMsg)
        this.correctErrorLog({
          eventName: '上传图片出错',
          errorMessage: errMsg
        })
        console.log(e)
        return
      }
      this.submitTxt = '提交批改中'
      const { teacherOperateType, isSupervise, isRemind, remark, operateTypeName, score } = this.$refs.correctOperate
      let { query, userId, linkType, linkId, buttonType } = this
      let { classTypeId, lessonId, xkhTeacherCourseId } = query
      classTypeId = Number(classTypeId)
      lessonId = Number(lessonId)
      xkhTeacherCourseId = Number(xkhTeacherCourseId)
      linkType = Number(linkType)
      userId = Number(userId)
      const params = {
        classTypeId,
        lessonId,
        xkhTeacherCourseId,
        linkType,
        userId,
        linkId,
        remark,
        teacherOperateType,
        isRemind,
        detailList,
        buttonType,
        classCorrectOptType: 1
      }
      if (audioUrl) {
        // 录音 mp3 地址
        params.audioUrl = audioUrl
        // 录音时长
        params.audioDuration = audioDuration
      }
      // 有分数
      if (isNumeric(score)) {
        params.score = Number(score)
        // 有分数时上报
        const { classTypeId, groupId, lessonId, aiLessonId, userId } = this.$route.query
        correctLogger.score({
          studentId: userId,
          groupId,
          lessonId,
          aiLessonId,
          courseId: classTypeId,
          linkType: this.linkTypeName
        })
      }
      this.sendToFamily = false
      const apiTime = this.getCurTime()
      try {
        const res = await this.$service.correction.postCorrectionList(params)
        console.log(res, 'res')
        const endCheckTime = this.getCurTime()
        // 批改一份的用时
        const correctTime = endCheckTime - this.correctTime
        // 如果有下一份，批改下一份时使用
        this.correctTime = endCheckTime
        // 批改日志
        correctLogger.submitCorrect({
          ...this.getLoggerData(),
          // 批改一份的用时(单位：秒)
          correctTime: parseInt(correctTime / 1000),
          // 是否有总评语
          isRemark: !!remark,
          // 是否有语音点评
          isAudio: !!audioUrl,
          // 批改结果类型
          teacherOperateType,
          // 批改结果类型名称
          operateTypeName,
          // 提醒家长表扬学生是否勾选
          isPraiseChecked: !!(!isSupervise && isRemind),
          // 提醒家长督促学生是否勾选
          isSuperviseChecked: !!(isSupervise && isRemind)
        })
        const { userId: nextUserId, linkType: nextLinkType } = res
        if (nextUserId) {
          // 有下一份，重新加载组件
          this.userId = nextUserId
          this.linkType = nextLinkType
          this.reloadCorrect()
          return
        }
        // 没有下一份，返回上一页
        this.$router.go(-1)
      } catch (error) {
        this.correctInfoLog({
          eventName: '批改接口出错',
          data: error && error.message ? error.message : error
        })
        // 310000000: "批改错误"
        // 31001:"发送失败，该小组不在您名下"
        // 31002: "发送失败，课程被修改"
        // 31003:"发送失败，学员已不在组内，即将打开下一份"
        // 31004: "无待批改内容"
        // 31005: "发送失败，学员已不在组内"
        // 31006:"发送失败，学生已经提交最新自评订正，即将自动打开"
        switch (error.errorCode) {
          // 提示消失后，返回批改详情页
          case 310000000: // 批改错误，预料不到的异常情况
          case 31004: // 无待批改内容
          case 31005: // 发送失败，学员已不在组内
            this.clearWarnTimer()
            this.warnTimeOutTimer = setTimeout(() => {
              this.goRouter('checkDetailsPage', this.query)
            }, this.warnSpeed)
            return false
            // 提示消失后，返回上课与批改主页面
          case 31001: // 发送失败，该小组不在您名下
          case 31002: // 发送失败，课程被修改
            this.clearWarnTimer()
            this.warnTimeOutTimer = setTimeout(() => {
              this.goRouter('classList')
            }, this.warnSpeed)
            return false
            // 自动打开最新
          case 31003:
            // 发送失败，学员已不在组内，即将打开下一份（其他学生）
            this.userId = -1
            this.reloadCorrect()
            return false
          case 31006:
            // 发送失败，学生已经提交最新自评订正，即将自动打开（当前学生）
            this.reloadCorrect()
            return false
          default:
            return false
        }
      } finally {
        if (imgUploadNum) {
          const curTime = this.getCurTime()
          this.correctInfoLog({
            eventName: '批改用时',
            data: {
              // 提交总用时
              allTime: curTime - allTime,
              apiTime: curTime - apiTime,
              // 图片总的上传时间
              imgUploadTime,
              // 上传图片的个数
              imgUploadNum,
              // 上传的图片地址和单个图片的时间
              imgUploadFiles,
              // 存储鉴权的时间
              imgStorageTime,
              // 图片合成时间
              imgCreateTime,
              // 录音上传时间
              audioUploadTime
            }
          })
        }
      }
    },
    /**
     * 下一份，重新加载批改组件
     */
    reloadCorrect() {
      // 提交批改按钮重置状态
      this.confirmDisabled = true
      this.showCorrect = false
      this.$nextTick(() => {
        this.showCorrect = true
      })
    },
    /**
     * 清除延时计时器
     */
    clearWarnTimer() {
      this.warnTimeOutTimer && clearTimeout(this.warnTimeOutTimer)
    },
    /**
     * 路由跳转
     */
    goRouter(path, query) {
      this.$router.push({
        path,
        query
      })
    },
    /**
     * 查看答案
     */
    showAnswer() {
      // 埋点
      correctLogger.answerBtn(this.getLoggerData())
      const { isWorkword, isFirstExamWord } = this
      if (isWorkword) {
        this.$refs.answerModal.show()
      }
      if (isFirstExamWord) {
        this.$refs.answerModal.show(true)
        // this.$refs.picAnswer.showAnswer()
      }
    },
    // 埋点公共参数
    getLoggerData() {
      const { userId, query, linkTypeName, linkType } = this
      const { classTypeId, lessonId, groupId } = query
      return {
        groupId: Number(groupId),
        lessonId: Number(lessonId),
        courseId: Number(classTypeId),
        studentUserId: Number(userId),
        linkTypeName,
        linkType: Number(linkType)
      }
    },
    // 开始录音按钮
    startRecord() {
      // 埋点
    },
    /**
     * 批改结果选中
     */
    resultChange(curResult) {
      this.confirmDisabled = false
      this.addSeal(curResult)
    },
    /**
     * 添加盖章
     * curResult 当前批改结果
     * onlyChange 如果存在就修改，如果不存在也不添加
     */
    addSeal(curResult, onlyChange) {
      // 打回订正，不显示盖章，如果印章已经存在，则执行删除操作
      const { type } = curResult
      const isDelete = type === 4
      if (this.isShowSeal) {
        this.$refs.correctStage.addSeal(curResult, isDelete, onlyChange)
      }
    },
    /**
     * 图片翻页，上一页，下一页
     */
    imgPageChange(imgIndex) {
      // const {} = this.$refs.correctStage
      // 点击上一页下一页的时候如果有盖章，则将章挪到这一页
      const { curResult } = this.$refs.correctOperate
      if (!curResult) {
        return
      }
      this.addSeal(curResult, true)
    },
    /**
     * 打分
     * isFirst 是否在第一页上打分
     * firstCheckbox
     */
    markScore(val, isFirst, firstCheckbox) {
      const { correctStage } = this.$refs
      console.log('isFirst', isFirst)
      // 分数打在第一页上 选中
      if (isFirst === true) {
        correctStage.scoreIndex = 0
      }
      // 分数打在第一页上 取消选中
      if (firstCheckbox && isFirst === false) {
        correctStage.scoreIndex = correctStage.imgIndex
      }
      correctStage.markScore(val)
    },
    /**
     * 点击批改的工具
     */
    changeTool(name) {
      // 埋点
      // TODO 重新埋，有新增的操作
      let logName
      if (name === 'addRight') {
        logName = 'rightIcon'
      }
      if (name === 'addWrong') {
        logName = 'wrongIcon'
      }
      if (name === 'handlexRotate') {
        logName = 'rotate'
      }
      if (name === 'confirmClear') {
        logName = 'clearCanvas'
      }
      if (name === 'zoomOut') {
        logName = 'zoomOut'
      }
      if (name === 'zoomIn') {
        logName = 'zoomIn'
      }
      if (logName) {
        correctLogger[logName](this.getLoggerData())
      }
    },
    correctErrorLog(data) {
      const { userId, studentName, linkTypeName, linkId, userInfo } = this
      return kibanaErrorLog([
        {
          eventType: 'correctLog',
          eventId: 'correct-submit',
          studentId: userId,
          studentName,
          linkTypeName,
          linkId,
          userInfo,
          ...data
        }
      ])
    },
    correctInfoLog(data) {
      const { userId, studentName, linkTypeName, linkId, userInfo } = this
      return kibanaInfoLog([
        {
          eventType: 'correctLog',
          eventId: 'correct-info',
          studentId: userId,
          studentName,
          linkTypeName,
          linkId,
          userInfo,
          ...data
        }
      ])
    },
    /**
     * 没有批改
     */
    noCorrect() {
      this.correctInfoLog({
        eventName: '没有在图片上进行批改操作'
      })
    },
    /**
     * 删除物件
     */
    objectDelete(name) {
      if (name === 'ScoreGroup') {
        this.$refs.correctOperate.score = ''
      }
    },
    /**
     * 点击将分数展示在第1页
     */
    firstScoreClick(val) {
      if (val) {
        // 跳转到第1页
        const { correctStage } = this.$refs
        correctStage.imgIndex = 0
      }
    }
  },
  filters: {
    formatDate(date) {
      if (!date || date == null) return null
      date = new Date(date)
      let fmt = 'yyyy/MM/dd hh:mm'
      const obj = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes()
      }
      for (var k in obj) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 4 ? obj[k] : ('00' + obj[k]).substring(('' + obj[k]).length))
        }
      }
      return fmt
    }
  }
}
</script>
<style lang="less" scoped>
body {
  -webkit-user-select: none;
}
.check-container {
  width: 100%;
  height: calc(100vh - 120px);
  overflow: hidden;
  background: #fff;
  :deep(.ant-page-header) {
    padding: 5px;
    background: #fff;
    box-shadow: inset 0px -1px 0px #ebedf0;
    .ant-page-header-heading-title{
      color: #303858;
    }
  }
  :deep(.ant-layout) {
    height: 100%;
    background: #fff;
  }
  .ant-layout-sider {
    padding: 20px 20px 15px;
    background: #fff;
    border-left: 1px solid #ebedf0;
    position: relative;
  }
  .operate-page {
    margin: 0 20px 15px 0;
    border-left: 1px solid #EBEDF0;
    padding-left: 8px;
    color: #3262FD;
  }
  // .operate-right-top {
  //   button.ant-btn.ant-btn-primary {
  //     color: #FFFFFF;
  //   }
  //   button.ant-btn.ant-btn-primary.actived {
  //     border-color: #2357FF;
  //     background-color: #2357FF;
  //   }
  // }
  .info {
    font-size: 14px;
    color: #505873;
    // height: calc(100vh - 172px);
    height: 100%;
    padding: 0;
    :deep(.ant-layout-sider-children) {
      padding-bottom: 64px;
      position: relative;
    }
    .operate-right-top {
      overflow-x: hidden;
      overflow-y: auto;
      height: 100%;
      padding: 20px;
    }
    .send-stu-btn {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
    }
  }
}
.result-send-checkbox {
    padding-top: 9px;
  }
.check-group-name {
  padding: 0 !important;
  :deep(.ant-page-header-heading) {
    display: flex;
    height: 64px;
    align-items: center;
  }
  :deep(.ant-page-header-back) {
    padding: 0 18px 0 26px;
    margin: 0;
  }
  :deep(.ant-page-header-heading-title) {
    flex: 1;
    font-size: 14px;
    font-weight: normal;
    display: inline-flex;
    overflow: hidden;
    justify-content: space-between;
    padding-right: 24px;
    .title-h1 {
      font-size: 16px;
      font-weight: 700;
    }
    .title-h2 {
      color: #505873;
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .title-left, .title-right {
      span {
        display: inline-block;
        padding: 0 16px;
        position: relative;
        &:before {
          position: absolute;
          content: "";
          width: 1px;
          height: 16px;
          background: #EBEDF0;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        &:first-child {
          padding-left: 0;
          &:before {
            width: 0;
          }
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
    .title-left {
      flex: 1;
      display: inline-flex;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      align-items: center;
      color: #505873;
      span {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        // &:last-child {
        //   flex: 1;
        //   overflow: hidden;
        //   text-overflow:ellipsis;
        //   white-space: nowrap;
        // }
      }
      .link-type {
        display: inline-block;
        height: 24px;
        padding: 0 6px;

        /* 插画/Draw_1 */

        background: #E9F5FF;
        border-radius: 4px;
        font-size: 12px;
        color: #1E96FE;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -12px;
        margin-right: 16px;
      }
    }
    .title-right {
      word-break: keep-all;
      color: #98A2B2;
      min-width: 380px;
      display: flex;
      align-items: center;
      justify-content:flex-end;
      .strong {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
}

</style>
